import { LoanDetails } from "../../_store/loan";
import {
  IStoreSelector,
  useApplicationState,
} from "../../_store/useApplicationState";
import { BasicVehicleInformation } from "./BasicVehicleInformation";
import { IApplicationStep } from "../../_store/application";

export const VehicleInformation = (
  props: IStoreSelector<LoanDetails> & IApplicationStep
) => {
  const application_store = useApplicationState((s) => s.application_store);
  const loan_type = application_store((s) => s.loan_type);
  return (
    <div className="">
      <h2>Vehicle</h2>
      <div className="grid margin-responsive">
        <BasicVehicleInformation step={props.step} />
      </div>
    </div>
  );
};
